export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13814.3dc8fd79.jpg";